// The dashboard's building blocks: the shared UI kit (packages/ui), which the admin back-office uses too.

import { Modal as BaseModal } from '@cck/ui';
import type { ComponentProps } from 'react';
import { useI18n } from '../i18n/index.ts';

export * from '@cck/ui';

/** The kit's modal, with its close button labelled in the dashboard's language. */
export function Modal(props: ComponentProps<typeof BaseModal>) {
  const { t } = useI18n();
  return <BaseModal closeLabel={t('common.close')} {...props} />;
}
